export default "__VITE_ASSET__BoqUGRlP__"